import React from "react";
import "./Faculty.css";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const Faculty = () => {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0,-10000); 
    document.documentElement.scrollTo(0, -10000);// Scroll to top on route change
  }, [pathname]);

  const facultyMembers = [
    { id: 1, src: "/images/faculty-1.png", name: "Dr. Isha Jaswal", title: "Associate Professor" },
    { id: 2, src: "/images/faculty-2.png", name: "Ms. Neha Mangla", title: "Assistant Professor" },
    { id: 3, src: "/images/faculty-3.png", name: "Ms. Priya Jindal", title: "Assistant Professor" },
    { id: 4, src: "/images/faculty-4.png", name: "Dr. Harsha Trivedi", title: "Assistant Professor" },
    { id: 5, src: "/images/faculty-5.png", name: "Ms. Ekta Garg", title: "Assistant Professor" },
    { id: 6, src: "/images/faculty-6.png", name: "Ms. Jyotika Saraswat", title: "Assistant Professor" },
    { id: 7, src: "/images/faculty-7.png", name: "Ms. Vipra Jain", title: "Assistant Professor" },
    { id: 8, src: "/images/faculty-8.png", name: "Mr. Sourish Dutta", title: "Assistant Professor" },
    { id: 9, src: "/images/faculty-9.png", name: "Ms. Soumya Mahajan", title: "Assistant Professor" },
    { id: 10, src: "/images/faculty-10.png", name: "Ms. Khushboo Gupta", title: "Assistant Professor" },
    { id: 11, src: "/images/faculty-11.png", name: "Ms. Lavi Vats", title: "Assistant Professor" },
    { id: 12, src: "/images/faculty-12.png", name: "Dr. Sachin Gupta", title: "Dean Research & Publication" },
    { id: 13, src: "/images/faculty-13.png", name: "Ms. Jyotsana Joshi", title: "Assistant Professor" },
    { id: 14, src: "/images/faculty-14.png", name: "Ms. Sonika", title: "Assistant Professor" },
    { id: 15, src: "/images/faculty-15.png", name: "Ms. Sakshi Bhayana", title: "Assistant Professor" },
    { id: 16, src: "/images/faculty-16.png", name: "Ms. Priyanka Gupta", title: "Assistant Professor" },
    { id: 17, src: "/images/faculty-17.png", name: "Dr. Divya Sharma", title: "Assistant Professor" },
    { id: 18, src: "/images/faculty-18.png", name: "Ms. Sunil Kumari", title: "Assistant Professor" },
  ];

  const coreImages = [
    { id: 1, src: "/images/core-1.png", title: "President", name: "Naisha" },
    { id: 2, src: "/images/core-2.png", title: "Vice - President", name: "Aesha" },
    { id: 3, src: "/images/core-3.png", title: "General Secretary", name: "Raam" },
    { id: 4, src: "/images/core-4.png", title: "Joint Secretary", name: "Yash" },
    { id: 5, src: "/images/core-5.png", title: "Joint Secretary", name: "Arpita" },
    { id: 6, src: "/images/core-6.png", title: "Cultural Secretary", name: "Pranav" },
    { id: 7, src: "/images/core-7.png", title: "Marketing Head", name: "Gauri" },
    { id: 8, src: "/images/core-8.png", title: "Design Head", name: "Himanshi" },
    { id: 9, src: "/images/core-9.png", title: "PR Head", name: "Tushita" },
    { id: 10, src: "/images/core-10.png", title: "Content Head", name: "Anushka" },
  ];

  const techTeam = [
    { id: 1, src: "/images/IMG_20250301_180652.jpg", title: "Frontend System Integrator & Developer", name: "Ayush Dey" },
    { id: 2, src: "/images/IMG_9948.jpeg", title: "Frontend Systems & Deployment Engineer", name: "Dhruvi Gaira" },
    { id: 3, src: "/images/IMG_20241121_095618.jpg", title: "Backend & DevOps Engineer", name: "Shashwat Tripathi" },
    { id: 4, src: "/images/IMG_9687 2.jpg", title: "Technical Lead & Backend Developer", name: "Shlok Anand" },
  ];

  const convener = [
    { id: 1, src: "/images/faculty-3.png", name: "Ms. Priya Jindal", title: "Assistant Professor" }
    
  ];

  const co_convener = [
    { id: 1, src: "/images/faculty-6.png", name: "Ms. Jyotika Saraswat", title: "Assistant Professor" },
    
  ];


  return (
    <div className="faculty-page">
      <main>
        <div className="chutiye">
          {/* Convener */}
          <section id="convener-section" className="faculty-section">
            <h1>Convener</h1>
            <div className="faculty-grid">
              {convener.map((member) => (
                <div className="faculty-card" key={member.id}>
                  <img src={member.src} alt={member.name} className="faculty-image" />
                  <div className="faculty-info">
                    <h3>{member.name}</h3>
                    <p>{member.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
  
          {/* Co-Convener */}
          <section id="co-convener-section" className="faculty-section">
            <h1>Co-Convener</h1>
            <div className="faculty-grid">
              {co_convener.map((member) => (
                <div className="faculty-card" key={member.id}>
                  <img src={member.src} alt={member.name} className="faculty-image" />
                  <div className="faculty-info">
                    <h3>{member.name}</h3>
                    <p>{member.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

       {/* Alumni Relations Committee */}
      <section id="alumni-team" className="faculty-section">
        <h1>Alumni Relations Committee</h1>
        <div className="image-grid">
          {coreImages.map((member) => (
            <div className="image-card" key={member.id}>
              <img src={member.src} alt={member.title} className="profile-image" />
              <div className="core-info">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Technical Team Section */}
      <section id="tech-team" className="faculty-section">
        <h1>Technical Team</h1>
        <div className="image-grid">
          {techTeam.map((member) => (
            <div className="image-card" key={member.id}>
              <img src={member.src} alt={member.title} className="profile-image" />
              <div className="core-info">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Faculty Members Section */}
      {/* <section id="faculty-section" className="faculty-section">
        <h1>Faculty</h1>
        <div className="faculty-grid">
          {facultyMembers.map((member) => (
            <div className="faculty-card" key={member.id}>
              <img src={member.src} alt={member.name} className="faculty-image" />
              <div className="faculty-info">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            </div>
          ))}
        </div>
        </section> */}

      </main>
    </div>
  );
};

export default Faculty;
